import { render, staticRenderFns } from "./ActionHabitsDisplaySelection.vue?vue&type=template&id=c13f9108&scoped=true&"
import script from "./ActionHabitsDisplaySelection.vue?vue&type=script&lang=js&"
export * from "./ActionHabitsDisplaySelection.vue?vue&type=script&lang=js&"
import style0 from "./ActionHabitsDisplaySelection.vue?vue&type=style&index=0&id=c13f9108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13f9108",
  null
  
)

export default component.exports